import { Component, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { merge, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'mat-error[flowValidationErrors]',
  standalone: true,
  imports: [AsyncPipe],
  template: `{{ error$ | async }}`
})
export class ValidationErrorComponent implements OnInit {
  error$!: Observable<string | null>;

  private readonly errorList: Record<string, string> = {
    required: 'global.validations.required',
    invalidEmail: 'global.validations.invalidEmail',
    validatePhoneNumber: 'global.validations.invalidPhoneNumber',
    minlength: 'global.validations.min_length',
    maxlength: 'global.validations.max_length',
    duplicateName: 'settings.sensorSettings.validation.nameDuplicate',
    generic: 'global.validations.generic'
  };

  constructor(
    private ngControl: NgControl,
    private translateService: TranslateService
  ) { }


  ngOnInit() {
    if (this.ngControl) {
      this.error$ = merge(
        this.ngControl.statusChanges!,
        this.ngControl.valueChanges!
      ).pipe(
        startWith(null),
        map(() => {
          const errors = this.ngControl.errors;
          if (!errors) return null;

          const firstKey = Object.keys(errors)[0];
          const translationKey = this.errorList[firstKey] || this.errorList.generic;

          return this.translateService.instant(translationKey, errors[firstKey]);
        })
      );
    }
  }
}